var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseAlert',{staticClass:"tw-block",attrs:{"title":"Approved"}},[_vm._v(" "+_vm._s(_vm.approvedText)+" "),(_vm.canRetractApproval)?_c('div',[_c('button',{staticClass:"tw-font-semibold tw-underline",attrs:{"data-cy":"btn-undo-approval"},on:{"click":function($event){return _vm.$emit('retract')}}},[_vm._v(" Undo Approval ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }